export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'displayImage',
    title: that.$l('table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_sample_name') || '样品名称',
    field: 'sampleName',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'sampleName' },
  },
  {
    title: that.$l('table_label_color_size') || '尺寸颜色',
    field: 'colorSize',
    width: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'colorSize' },
  },
  {
    title: that.$l('table_label_fabirc_desc') || '面料构成',
    field: 'fabricDesc',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_qty') || '样品数量',
    field: 'qty',
    width: 120,
    align: 'left',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 99999999,
        step: 1,
        'controls-position': 'right',
      },
    },
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_scm_name') || '成品工厂',
    field: 'scmName',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
]
